import { useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

/**
 * Breakpoint hook Xs (36em)
 */
export function useIsXsUp() {
  const theme = useMantineTheme()
  return useMediaQuery(`(min-width: ${theme.breakpoints.xs})`)
}

/**
 * Breakpoint hook Sm (48em)
 */
export function useIsSmUp() {
  const theme = useMantineTheme()
  return useMediaQuery(`(min-width: ${theme.breakpoints.sm})`)
}

/**
 * Breakpoint hook Md (62em)
 */
export function useIsMdUp() {
  const theme = useMantineTheme()
  return useMediaQuery(`(min-width: ${theme.breakpoints.md})`)
}

/**
 * Breakpoint hook Lg (75em)
 */
export function useIsLgUp() {
  const theme = useMantineTheme()
  return useMediaQuery(`(min-width: ${theme.breakpoints.lg})`)
}

/**
 * Breakpoint hook Xl (88em)
 */
export function useIsXlUp() {
  const theme = useMantineTheme()
  return useMediaQuery(`(min-width: ${theme.breakpoints.xl})`)
}
